export function ofsaStickyTopbar() {
	'use strict';

	const topbar = document.querySelector( '.site-topbar' );

	if ( topbar ) {
		const mq = window.matchMedia( '(min-width: 1024px)' );

		const onScroll = () => {
			const scrolled = mq.matches && window.scrollY > 50;
			topbar.classList.toggle( 'site-topbar--scrolled', scrolled );
		};

		window.addEventListener( 'scroll', onScroll, { passive: true } );
		mq.addEventListener( 'change', onScroll );
		onScroll();
	}
}
